import { render, staticRenderFns } from "./panelCarving.vue?vue&type=template&id=94873db6&scoped=true"
import script from "./panelCarving.vue?vue&type=script&lang=js"
export * from "./panelCarving.vue?vue&type=script&lang=js"
import style0 from "./panelCarving.vue?vue&type=style&index=0&id=94873db6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94873db6",
  null
  
)

export default component.exports